import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const IncompleteInfo = React.lazy(() => import('@/pages/USER/UpdateInfomation/IncompleteInfoForm'))
const Home = React.lazy(() => import('@/pages/ANONYMOUS/Home'))
const Eform = React.lazy(() => import('@/pages/ANONYMOUS/Eform/Eform'))
const OfficerRegistration = React.lazy(() => import('@/pages/ANONYMOUS/OfficerRegistration'))
const ListAppointments = React.lazy(
  () => import('@/pages/ANONYMOUS/MyAppoinments/ListAppointments')
)
const GuestRegister = React.lazy(() => import('@/components/common/Login/GuestLogin'))
const MeetingDetail = React.lazy(() => import('@/pages/ANONYMOUS/MeetingDetail'))
// Màn đăng ký khách mới
const GuestRegistrationPage = React.lazy(() => import('@/pages/ANONYMOUS/GuestRegistration'))
const PublicRegistration = React.lazy(() => import('@/pages/ANONYMOUS/PublicRegistration'))
const GoogleCallback = React.lazy(() => import('@/pages/ANONYMOUS/GoogleCallback'))

export const publicRoutes = [
  {
    path: ROUTER.AUTH_CALLBACK,
    element: (
      <LazyLoadingComponent>
        <GoogleCallback />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.CAP_NHAT_THONG_TIN,
    element: (
      <LazyLoadingComponent>
        <IncompleteInfo />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.HOME,
    element: (
      <LazyLoadingComponent>
        <Home />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DANG_KY_LICH_HOP,
    element: (
      <LazyLoadingComponent>
        <Eform />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DANG_KY_RA_VAO,
    element: (
      <LazyLoadingComponent>
        <OfficerRegistration />
      </LazyLoadingComponent>
    ),
  },
  // {
  //   path: ROUTER.DANG_KY_KHACH,
  //   element: (
  //     <LazyLoadingComponent>
  //       <OfficerRegistration />
  //     </LazyLoadingComponent>
  //   ),
  // },
  // Màn đăng ký khách mới
  {
    path: ROUTER.DANG_KY_KHACH,
    element: (
      <LazyLoadingComponent>
        <GuestRegistrationPage />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.LICH_HOP_CUA_TOI,
    element: (
      <LazyLoadingComponent>
        <ListAppointments />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DANG_KY_THONG_TIN_KHACH,
    element: (
      <LazyLoadingComponent>
        <GuestRegister />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.DANG_KY_NGUOI_DUNG_DAY_DU,
    element: (
      <LazyLoadingComponent>
        <PublicRegistration />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.CHI_TIET_LICH_HOP,
    element: (
      <LazyLoadingComponent>
        <MeetingDetail />
      </LazyLoadingComponent>
    ),
  },
]
